import * as React from 'react';
import { Button, Modal, Spin, Form, Typography, Select, InputNumber, Input, Table } from 'antd';
import { useEffect, useState } from 'react';
import { AuthApi } from '../../apis/auth-api';
import { CountryPhoneNumberPrefix } from '../../models/country-phone-number-prefix-interface';
import ReactCountryFlag from "react-country-flag";
import { UserPhoneAuthentication } from '../../models/user-phone-authentication-interface';
import MaskedInput from 'antd-mask-input';
import { Logger } from '../../utilites/loglySetup';
import { Profile } from '../../models/profile-interface';
import { Feature } from '../../models/product-interface';
const { Text } = Typography;
const { Option } = Select;

type Props = {
    allFeatures: Feature[];
    currentFeatures: Feature[];
    isModalVisible: boolean,
    setIsModalVisible: React.Dispatch<React.SetStateAction<boolean>>,
    isLoading: boolean,
    setIsLoading: React.Dispatch<React.SetStateAction<boolean>>,
    handleAddFeatures: (data: Feature[]) => void;
};

const AddFeaturesModal: React.FC<Props> = ({
    allFeatures,
    currentFeatures,
    isModalVisible,
    setIsModalVisible,
    isLoading,
    setIsLoading,
    handleAddFeatures,
}) => {
    const [isBtnDisabled, setIsBtnDisabled] = useState<boolean>(true);
    const [selectedRowKeys, setSelectedRowKeys] = useState<number[]>([]);
    const [featuresWithLimit, setFeaturesWithLimit] = useState<Feature[]>([]);
    /**
     * Cancel register 2fa form and return to login form
     */
    const handleCancel = () => {
        setIsModalVisible(false);
    };

    /**
     * Initial register 2fa form submission for validation
     */
    const handleOk = async () => {
        try {
          var featureList = allFeatures.filter(f => selectedRowKeys.includes(f.id) && !featuresWithLimit.some(l => l.id == f.id)).concat(currentFeatures)
          var limitFeatures = featuresWithLimit.filter(l => selectedRowKeys.includes(l.id))
          handleAddFeatures([...featureList, ...limitFeatures]);
          setSelectedRowKeys([]);
        } catch (errorInfo) {
            Logger().log("ErrorInfo: ", errorInfo);
        }
    };

    /**
     * Register 2fa form submission
     * @param values `country`, `phoneNumber`
     */
    const onFinish = async (values: { country: number, phoneNumber: string }) => {
        setIsLoading(false);
    };

    let columns = [
      {
        title: 'Feature',
        dataIndex: 'name',
        key: 'name',
        render: (name: string) => {
          return name
        },
        sorter: {
          compare: (a: { name: string; }, b: { name: string; }) => a.name.localeCompare(b.name)
        },
      },
      {
        title: 'Record Limit',
        dataIndex: 'allowLimit',
        key: 'allowLimit',
        render: (allowLimit: boolean, record: Feature) => {
          return allowLimit ? (
            <InputNumber
              id={`limit-${record.id}`}
              key={record.id}
              disabled={!selectedRowKeys.includes(record.id)}
              onChange={(value) => {
                var feature = record;
                feature.recordLimit = value;
                const newList = featuresWithLimit.filter(f => f.id == record.id)
                setFeaturesWithLimit([...newList, feature]);
              }}
              min={0}
            />
          ) : 'None'
        },
      }
    ];

     /**
    * On selection changes
    * @param selectedRowKeys
    */
      const onSelectChange = (selectedRowKeys) => {
        setSelectedRowKeys(selectedRowKeys);
        // setValue(value + 1);
    };

    const rowSelection = {
        selectedRowKeys,
        onChange: onSelectChange
    };

    return (
        <Modal
          centered
          title="Add Features"
          visible={isModalVisible}
          onCancel={handleCancel}
          onOk={handleOk}
          getContainer={false}
          width={700}
          footer={[
              <Button id="cancelAdd" key="back" onClick={handleCancel}>
                  Cancel
              </Button>,
              <Button id="addFeatures" key="addFeatures" type="primary" loading={isLoading} onClick={handleOk} disabled={!(selectedRowKeys?.length > 0)}>
                  Add Features
              </Button>
          ]}
        >
            <Spin spinning={isLoading}>
              <Table
                columns={columns}
                rowSelection={rowSelection}
                rowKey={(value) => value.id}
                size="small"
                dataSource={allFeatures?.filter(f => !currentFeatures?.some(cf => cf.id == f.id))}
              />
            </Spin>
        </Modal>
    )
}

export default AddFeaturesModal;